import { AxiosResponse } from "axios";

import $http from "./instance";

class UserClient {
	public static async getMyProfile(): Promise<AxiosResponse> {
		return $http.get(`/users/me`);
	}

	public static async linkMyEmail(email: string): Promise<AxiosResponse> {
		return $http.put(`/users/me/email/${encodeURIComponent(email)}`);
	}
}

export default UserClient;
